import React, { useState, useEffect } from "react";
import './StickyNote.scss';
interface Note {
  id: number;
  text: string;
  position: { x: number; y: number };
  color: string;
  date: any;
  title: string;
}
export interface Props {
  noteBtnText?: string;
  hideBtn?: boolean;
}
const StickyNotes = (
  {
    noteBtnText = "Add Note +",
    hideBtn
  }: Props
) => {
  const [notes, setNotes] = useState<Note[]>(() => {
    const savedNotes = localStorage.getItem("mfg-stickyNotes");
    return savedNotes ? JSON.parse(savedNotes) : [];
  });
  const getRandomColor = () => {
    const colors = [
      "#FFADAD", "#FFD6A5", "#FDFFB6", "#CAFFBF", 
      "#9BF6FF", "#A0C4FF", "#BDB2FF", "#FFC6FF"
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };
  useEffect(() => {
    localStorage.setItem("mfg-stickyNotes", JSON.stringify(notes));
  }, [notes]);

  const addNote = () => {
    const date = new Date();
    const newNote: Note = {
      title: "Note Title",
      id: Date.now(),
      text: "Note Content",
      position: { x: 100, y: 100 },
      color: getRandomColor(),
      date: date.toLocaleString("en-US", { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }),
    };
    setNotes([...notes, newNote]);
  };

  const updateNote = (id: number, text: string) => {
    setNotes(notes.map((note) => (note.id === id ? { ...note, text } : note)));
  };
  const updateNoteTitle = (id: number, title: string) => {
    setNotes(notes.map((note) => (note.id === id ? { ...note, title } : note)));
  };
  const deleteNote = (id: number) => {
    setNotes(notes.filter((note) => note.id !== id));
  };

  const handleDrag = (id: number, e: React.DragEvent<HTMLDivElement>) => {
    const newX = e.clientX;
    const newY = e.clientY;
    setNotes(
      notes.map((note) =>
        note.id === id ? { ...note, position: { x: newX, y: newY } } : note
      )
    );
  };

  return (
    <>
      {!hideBtn && <button
        onClick={addNote}
        className="mfg-noteAdd"
      >
        {noteBtnText}
      </button>
      }
      {notes.map((note) => (
        <div
          key={note.id}
          className="mfg-stickyNote"
          style={{
            top: note.position.y,
            left: note.position.x,
            cursor: "move",
            backgroundColor: note.color,
          }}
          draggable
          onDragEnd={(e) => handleDrag(note.id, e)}
        >
          <input type="text"
            onChange={(e) => updateNoteTitle(note.id, e.target.value)}
            placeholder = {note.title}
            />
          <textarea
            placeholder={note.text}
            onChange={(e) => updateNote(note.id, e.target.value)}
          />
          <button onClick={() => deleteNote(note.id)} className="mfg-deleteNote">
            X
          </button>
          <div className="mfg-date">{ note.date }</div>
        </div>
      ))}
    </>
  );
};

export default StickyNotes;
